exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".library .label-answer[data-v-74a6fb67] {\n  display: inline-block;\n}\n", ""]);
